import type { TSocialOfferSpotlight } from "@api";
import type { IAddress } from "@bbj-types/address";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "../axios";

export interface ISearchSocialOffersSpotlightResponse {
  data: TSocialOfferSpotlight[];
  limit: number;
  skip: number;
  total: number;
  count: number;
  orderStrategy: { strategy: string };
  metadata: {
    filtersHash: string;
  };
}

export interface ISearchSocialOffersSpotlightBody {
  candidateId?: ObjectId;
  orderStrategy?: {
    candidate?: string;
    model?: string;
    distanceFrom?: number;
    strategy: string;
  };
  metadata?: {
    filtersHash: string;
  };
  location?:
    | {
        typeOfLocation: "places";
        places: string[];
      }
    | {
        typeOfLocation: "radius";
        searchRadius: {
          radius: number;
          address: IAddress;
        };
      };
}

export const useSearchSocialOffersSpotlight = () => {
  const [state, execute, cancel] = axios<
    ISearchSocialOffersSpotlightResponse,
    ISearchSocialOffersSpotlightBody,
    unknown
  >(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );
  const callback = useCallback(
    (data: ISearchSocialOffersSpotlightBody) => {
      return execute({
        url: "/offers/social/spotlight",
        data: data,
      });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
